module.exports = __webpack_public_path__ + "static/What-Causes-Sciatica-5a1e30042346e4f67a3ea8b78b5677c1.webp";